import React from 'react'
import about from '../assets/images/bitcoin.svg'
import { Link } from 'react-router-dom'

export default function AboutOne() {
  return (
    <>
            <div className="row align-items-center">
                <div className="col-lg-5 col-md-6">
                    <img src={about} className="img-fluid" alt=""/>
                </div>

                <div className="col-lg-7 col-md-6 mt-4 mt-md-0 pt-2 pt-md-0">
                    <div className="section-title ms-lg-5">
                        <h4 className="title mb-3">Moving your Existing Solution <br/> for Cryptocurrency</h4>
                        <p className="text-muted para-desc mb-0">Our platform reaches people all over the world, hereby we are trusted as the best platform for crypto trading.</p>

                        <ul className="list-unstyled text-muted mb-0 mt-3">
                            <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Digital Marketing Solutions for Tomorrow</li>
                            <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Our Talented & Experienced Marketing Agency</li>
                            <li className="mb-1"><span className="text-primary h5 me-2"><i className="mdi mdi-check-circle-outline align-middle"></i></span>Create your own skin to match your brand</li>
                        </ul>

                        <div className="mt-4">
                            <Link to="" className="btn btn-link primary fs-6">Read More <i className="mdi mdi-arrow-right align-middle"></i></Link>
                        </div>
                    </div>
                </div>
            </div> 
    </>
  )
}
